(function () {
  var SECTION_SELECTOR = '.oddit-section-ticker-band';
  var sectionState = new Map();

  function initMarquee(section) {
    var track = section.querySelector('[data-marquee-track]');
    var firstSet = section.querySelector('[data-marquee-set]');
    if (!track || !firstSet) return null;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      var setWidth = firstSet.scrollWidth;
      var trackStyle = getComputedStyle(track);
      var trackGap = parseFloat(trackStyle.columnGap) || parseFloat(trackStyle.gap) || 0;
      var distance = setWidth + trackGap;
      track.style.setProperty('--marquee-distance', '-' + distance + 'px');
    }

    function enable() {
      measure();
      track.style.animationPlayState = 'running';
    }

    function disable() {
      track.style.animationPlayState = 'paused';
    }

    if (reducedMotion.matches) {
      disable();
    } else {
      enable();
    }

    var ro = new ResizeObserver(function () {
      if (!reducedMotion.matches) measure();
    });
    ro.observe(section);

    reducedMotion.addEventListener('change', function (e) {
      e.matches ? disable() : enable();
    });

    function handleVisibility() {
      if (reducedMotion.matches) return;
      track.style.animationPlayState = document.hidden ? 'paused' : 'running';
    }

    document.addEventListener('visibilitychange', handleVisibility);

    return { measure: measure, ro: ro, handleVisibility: handleVisibility };
  }

  function destroyMarquee(state) {
    if (!state) return;
    if (state.ro) state.ro.disconnect();
    if (state.handleVisibility) {
      document.removeEventListener('visibilitychange', state.handleVisibility);
    }
  }

  function initSection(section) {
    var state = { marquee: initMarquee(section) };
    sectionState.set(section.id, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section.id);
    if (!state) return;
    destroyMarquee(state.marquee);
    sectionState.delete(section.id);
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();